function initTabs() {
    // Prevent closing of the tab if it is already open
    document.querySelectorAll('.tabs__item .tabs__title').forEach(title => {
        title.addEventListener('click', e => {
            const details = title.parentElement;
            if (details.hasAttribute('open')) {
                e.preventDefault();
            }
        });
    });

    document.querySelectorAll(".tabs").forEach(tabs => {
        const pageId = tabs.dataset.pageId;
        tabs.querySelectorAll(".tabs__item").forEach(detail => {

            detail.addEventListener("toggle", async function () {

                if (!detail.open)
                    return;

                try {
                    const response = await fetch("/api/handbook/savetab/", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            pageId,
                            tab: detail.dataset.tab
                        })
                    });

                    if (!response.ok) {
                        console.log(await response.text());
                    }
                }
                catch (error) {
                    console.log(error);
                }
            });
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
} else {
    initTabs();
}